<template>
  <v-autocomplete
    label="Mata Pelajaran"
    :value="value"
    @change="handleChange"
    placeholder="Pilih Mata Pelajaran"
    :items="matapelajaran"
  >
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      matapelajaran: [],
    };
  },
  mounted() {
    this.getData();
  },
  props: ["value"],
  emits: ["change"],
  methods: {
    getData() {
      this.$root.app.http.get("/api/matapelajaran").then((res) => {
        res.data.forEach((item) => {
          this.matapelajaran.push({
            value: item.id,
            text: item.nama,
          });
        });
      });
    },
    handleChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
